/**
 * The provider refuses to cancel an activation — number or email alike — during the
 * first two minutes after purchase (EARLY_CANCEL_DENIED). The UI counts that window
 * down instead of letting the user press a button that can only fail.
 */
import { parseServerDate } from "@/lib/server-time";

export const CANCEL_LOCK_SECONDS = 120;

/** Seconds still to wait before `createdAt` can be cancelled. 0 once it is free. */
export function cancelSecondsLeft(createdAt: string | undefined, now: number): number {
  const created = parseServerDate(createdAt);
  if (Number.isNaN(created)) return 0;
  return Math.max(0, CANCEL_LOCK_SECONDS - Math.floor((now - created) / 1000));
}
